












































import RepairEstimateSideCard from "@/components/repair-estimate/RepairEstimateSideCard.vue";
import { activityLogName } from "@/lib/utility/activityLogName";
import { detailedDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { MrfiktivActivityLogViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import ContextMenu from "../utility/ContextMenu.vue";
import RefsSelected from "../utility/RefsSelected.vue";
import TimelineCard from "../utility/TimelineItem.vue";
import ActivityTimeLineItemDelete from "./ActivityTimeLineItemDelete.vue";
import { ClearanceApproval, IClearanceApproval } from "@/models/clearance-approval.entity";
import { Clearance, IClearance } from "@/models/clearance.entity";

@Component({
  components: {
    ActivityTimeLineItemDelete,
    ContextMenu,
    LatestEntriesCardEmpty,
    TimelineCard,
    RefsSelected,
    RepairEstimateSideCard
  }
})
export default class ActivityTimeLineItemCreateRef extends mixins(DarkModeHighlightMixin, PermissionMixin) {
  @Prop({})
  activityLogEntry!: MrfiktivActivityLogViewModelGen;

  value: {
    refType: ResourceEnum;
    refId: string;
    element: IRepairEstimate | IClearance | IClearanceApproval | null;
  } | null = null;

  isLoading = true;

  isNotFound = false;

  get name() {
    return activityLogName(this.activityLogEntry);
  }

  get date() {
    if (this.activityLogEntry.timestamp?.created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";
      return detailedDate(this.activityLogEntry.timestamp?.created, locale);
    }
    return this.$t("sign.DocumentDetail.noDate");
  }

  async mounted() {
    const targets = this.activityLogEntry.target;
    if (!targets) {
      return;
    }
    const target = targets[0];

    if (!target?.refId) {
      return;
    }
  }

  getUserDetails(userId: string) {
    return PartnerUserModule.maps.id.get(userId)[0];
  }

  openSideCard() {
    const ref = this.activityLogEntry.target?.[0];
    if (!ref) {
      return;
    }

    let element: IRepairEstimate | IClearance | IClearanceApproval | null = null;
    if (ref.refType === ResourceEnum.REPAIR_ESTIMATE) {
      element = new RepairEstimate({
        id: ref.refId,
        partnerId: this.activityLogEntry.partnerId
      });
    } else if (ref.refType === ResourceEnum.CLEARANCE) {
      element = new Clearance({
        id: ref.refId,
        partnerId: this.activityLogEntry.partnerId
      });
    } else if (ref.refType === ResourceEnum.CLEARANCE_APPROVAL) {
      element = new ClearanceApproval({
        id: ref.refId,
        partnerId: this.activityLogEntry.partnerId
      });
    }

    this.value = { refType: ref.refType as BackendResourceEnum, refId: ref.refId, element };
  }
}
